import SPA from "./pages/index";
function App() {
  return (
    <SPA />
  );
}

export default App;
